<section class="section quotations">
  <div class="clearfix">
    <h4 class="float-start mb-0">{{'entity.quotations'|translate}}</h4>
    <jbm-link-button class="float-end"
      [caption]="('ui.go-to'|translate) + ' ' + ('ui.the'|translate|lowercase) + ' ' + ('entity.quotations'|translate)"
      iconClass="fa fa-arrow-right"
      (onClick)="showQuotations()">
    </jbm-link-button>
  </div>
  <div *ngIf="summary" class="summary mt-3 clearfix">
    <div class="data-column big">
      <div class="title">Open offertes</div>
      <div class="value">{{summary.open.count}}</div>
      <div class="value secondair">{{summary.open.totalPrice | money}}</div>
    </div>
    <div class="data-column big">
      <div class="title">Verloopt binnen {{summary.expiringSoon.withinDays}} dagen</div>
      <div class="value">{{summary.expiringSoon.count}}</div>
      <div class="value secondair">{{summary.expiringSoon.totalPrice | money}}</div>
    </div>
    <div class="data-column big">
      <div class="title">Geaccepteerd</div>
      <div class="value">{{summary.accepted.count}}</div>
      <div class="value secondair">{{summary.accepted.totalPrice | money}}</div>
    </div>
  </div>
</section>
